import React, { FC } from 'react';
import cls from './MoreFunctionMenu.module.css';
import classNames from 'classnames';
import { MenuItem } from './MenuItem/MenuItem';

export const MoreFunctionMenu = ({ children, isArchive }) => {
    return (
        <div className={classNames(cls.wrapper, { [cls.isArchive]: isArchive })}>{children}</div>
    );
};
